import { ISelectorOption } from 'types/ISelectorOption';

export const STATUS_OPTIONS: ISelectorOption<string>[] = [
  { value: 'PENDING', label: 'En Attente' },
  { value: 'APPROVED', label: 'Approuvé' },
  { value: 'REJECTED', label: 'Refusé' },
];
